import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import CustomDialog from './CustomDialog';
import FileSelectDialog from './FileSelectDialog';
import Alert from '@mui/material/Alert';
import CollapsibleCard from './CollapsibleCard';
import LoginState from './LoginState';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import ReportList from './ReportList';
import { getPropertyType } from '../helpers/utils';
import { PDFDocument, utf16Encode } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';
import ModalConfirm from './ModalConfirm';

export default function OrderReview({ order, afterCompleted }) {
    const [confirm, setConfirm] = useState(false);
    const [comment, setComment] = useState('');
    const [toast, setToast] = useState([]);
    const [alert, setAlert] = useState();
    const [message, setMessage] = useState();
    const [paymentDialog, setPaymentDialog] = useState(false);
    const [listItems, setListItems] = useState()
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pdfTimestamp, setPdfTimestamp] = useState(null);

    const [borrowerName, setBorrowerName] = useState('');
    const [borrowerAddress, setBorrowerAddress] = useState('');
    const [paymentDate, setPaymentDate] = useState('');
    const [invoiceDate, setInvoiceDate] = useState('');
    const [inspectionType, setInspectionType] = useState('');
    const [propertyAddress, setPropertyAddress] = useState('');
    const [totalPayment, setTotalPayment] = useState('');
    const [allPaid, setAllPaid] = useState('');
    const [lineItems, setLineItems] = useState([]);
    const [payAtClosing, setPayAtClosing] = useState(false);

    useEffect(() => {
      if(!listItems) {
        const _getFiles = async () => {
          let response = await axios.get('/getfiles', { params: { pOrderID: order.orderID } });
          if(response.data){
            const all = response.data.comments.concat(response.data.files);
            const sorted = all.sort((a,b) => new Date(a.timestamp) - new Date(b.timestamp));
            setListItems(sorted);
            return true;
          }
          return false;
        }
        _getFiles();
      }
    }, [listItems,order]);

    useEffect(() => {
      if(borrowerName === '') {
        const getFileData = async () => {
          let response = axios.get('/getReceiptData', { params: { pFileID: order.orderID } });
          try {
            var resultData = (await response).data;
            setBorrowerName(resultData.borrowerName);
            setBorrowerAddress(resultData.borrowerAddress);
            setInvoiceDate(resultData.invoiceDate);
            setPaymentDate(resultData.paymentDate);
            setInspectionType(resultData.inspectionType);
            setPropertyAddress(resultData.propertyAddress);
            setTotalPayment(resultData.totalPayment);
            setAllPaid(resultData.allPaid);
            setLineItems(resultData.invoiceItems);
          }
          catch { 
            setAlert('Failed to Retreive Receipt Data'); 
            setMessage('Failed to Retreive Receipt Data');
          }
        }
        getFileData();
      }
    });

    const _submitComment = async (approved) => {
      setIsSubmitting(true);
      let response = await axios.get('/submitComment', {
        params: {
          pOrderID: order.orderID,
          pUserName: LoginState.userName,
          pComment: comment,
          pApproved: approved
        }
      });
      if(response.data) {
        let list = listItems;
        list.push(response.data);
        setListItems(list);
        setComment('');
      }
    }

    const GetPropertyType = () => {
      var unitCount = parseInt(order.numberOfUnits);
      if(unitCount > 1) { return unitCount + " Unit"; }
      return getPropertyType(order.propertyType);
    };

    const _submitReview = async (approved, pdfTimestamp) => {
      if(!approved && !comment){
        setToast(['error','A comment is required when changes are requested']);
        return;
      }
      setPaymentDialog(false);
      setToast([]);
      setIsSubmitting(true);
      setConfirm(false);

      var response = null;
      var params = null;
      var fileDocName = "";
      var fileDocType = "";
      const orderPropertyType = GetPropertyType();
      switch(order.orderType) {
        case "New Appraisal":
        case "New Appraisal Inspection":
          if(orderPropertyType === "SFR" || orderPropertyType === "PUD" || orderPropertyType === "1 Unit") {
            fileDocName = "Appraisal Report (1004)";
            fileDocType = "FNMA1004";
            break;
          }
          else if(orderPropertyType === "Condo (Attached)" || orderPropertyType === "Condo (Detached)") {
            fileDocName = "Appraisal Condominium Report (1073)";
            fileDocType = "FNMA1073";
            break;
          }
          else if (orderPropertyType === "2 Unit" || orderPropertyType === "3 Unit" || orderPropertyType === "4 Unit") {
            fileDocName = "Appraisal Income Property Report (1025)";
            fileDocType = "FNMA1025";
            break;
          }
          else
            break;
        case "Re-Inspection":
        case "Re-Certification":
        case "Form 1004D/442 Re-Inspection":
        case "Form 1004D/442 Re-Certification":
          fileDocName = "Appraisal Final Report (1004D)";
          fileDocType = "FNMA1004D";
          break;
        case "Desk Review":
        case "Form 2006/1033 Desk Review":
          fileDocName = "Appraisal Desk Review";
          fileDocType = "DeskReview";
          break;
        case "Field Review":
        case "Form 2000/1032 Field Review":
          fileDocName = "Appraisal Field Review";
          fileDocType = "DeskReview";
          break;
        case "Rent Schedule":
        case "Form 1007 Rent Schedule":
          fileDocName = "Single Family Comparable Rent Schedule (1007)";
          fileDocType = "FNMA1007";
          break;
        case "Exterior Only":
        case "Form 2055 Exterior Only":
          fileDocName = "Appraisal Exterior-Only Inspection Report (2055)";
          fileDocType = "FNMA2055";
        case "Operating Income Statement":
        case "Form 216 Operating Income Statement":
          fileDocName = "Operating Income Statement (216)";
          fileDocType = "FNMA216";
          break;
        case "Rent Schedule + Operating Income Statement":
        case "Form 1007 Rent Schedule + Form 216 Operating Income Statement":
          fileDocName = "Comparable Rent and Operating Income";
          fileDocType = "FNMA1007+216";
          break;
        default:
          break;
      }

      // get pdf with matching timestamp
      if(pdfTimestamp)
      {
        var fileContent = null;
        for(var i=0; i<listItems.length; i++) {
          if(listItems[i].name && ("" + listItems[i].name).toLowerCase().includes(".pdf") && listItems[i].timestamp === pdfTimestamp) {
            // download this file and submit to byte
            response = axios.get('/getamcfiledata', { params: { pOrderID: order.orderID, pFileName: listItems[i].name } });
            try {
              var resultData = (await response).data;
              fileContent = resultData;
            }
            catch {
              setIsSubmitting(false);
              setAlert('Error Retreiving PDF File!');
              setMessage('Error Retreiving PDF File!');
              return;
            }

            // upload pdf
            params = {
              docType: fileDocType,
              docName: fileDocName,
              fileID: order.lenderFileID,
              orderID: order.orderID,
              fileName: fileDocName + ".pdf",
              fileContent: fileContent,
            };
            if(fileDocName) {
              axios.post('/UploadAndNotify', params)
              .then((response) => {
                const data = String(response.data);
                // error check
                if (!data.startsWith('Success')) {
                  setAlert('Error Uploading PDF File!');
                  setMessage('Error Uploading PDF File!');
                  return;
                }
              })
              .catch(() => {
                setAlert('Error Uploading PDF File!');
                setMessage('Error Uploading PDF File!');
              });
            }
            break;
          }
        }
      }

      response = await axios.get('/changestatus', {
        params: {
          pOrderID: order.orderID,
          pStatus: approved ? 'UW Review' : 'AMC Review'
        }
      });
      if(response.data) {
        await _submitComment(approved ? '[Approved By AMC]' : '');
        setIsSubmitting(false);
        afterCompleted();
      }
    }

    const _handleInputChange = e => {
        e.preventDefault();
        setComment(e.target.value);
    }

    const _handleApproval = () => {
      // if not paid, and have not selected - pay at closing.
      if((order.paid === "Pending" || order.paid === "---") && order.payOption !== "Pay At Closing") {
        setPaymentDialog(true);
      } else {
        setConfirm(true);
      }
    }

    const _deleteFile = async (orderID, fileName) => {
      if(fileName.startsWith("comment-")) {
        var timestamp = fileName.substring(8);
        let response = await axios.get('/deleteComment', {
          params: { pOrderID: orderID, pTimestamp: timestamp },
        });
        if (response.data) {
          setAlert(`Successfully Deleted Comment!`);
          setMessage(`Successfully Deleted Comment!`);
          for(var i=0; i<listItems.length; i++) {
            if(listItems[i] && listItems[i].timestamp && listItems[i].timestamp.toString() === timestamp.toString()) {
              listItems.splice(i, 1);
              break;
            }
          }
          setListItems(null); // if I don't do this, it won't refresh the display
          setListItems(listItems); // refresh list display
        }
        else {
          setAlert(`Error Deleting Comment!`); 
          setMessage(`Error Deleting Comment!`); 
        }
      }
      else {
        let response = await axios.get('/deleteReportFile', {
          params: { pOrderID: orderID, pFileName: fileName },
        });
        if (response.data) {
          setAlert(`Successfully Deleted File ${fileName}!`);
          setMessage(`Successfully Deleted File ${fileName}!`);
          for(var i=0; i<listItems.length; i++) {
            if(listItems[i] && listItems[i].name && listItems[i].name === fileName) {
              listItems.splice(i, 1);
              break;
            }
          }
          setListItems(null); // if I don't do this, it won't refresh the display
          setListItems(listItems); // refresh list display
        }
        else {
          setAlert(`Error Deleting File ${fileName}!`); 
          setMessage(`Error Deleting File ${fileName}!`); 
        }
      }
    }

    const _downloadFile = async (orderID, fileName) => {
      var response = axios.get('/getfiledata', { params: { pOrderID: orderID, pFileName: fileName } });
      try {
        var resultData = (await response).data;
        var dlFN = fileName;
        if(fileName[fileName.length-1] === ')') {
          dlFN = "";
          var splitFN = fileName.split(' ');
          for(var i=0; i<splitFN.length-1; i++) {
            dlFN = dlFN + splitFN[i];
          }
        }
        var binary = atob(resultData);
        var array = [];
        for (var j=0; j<binary.length; j++) {
          array.push(binary.charCodeAt(j));
        }
        var file = new Blob([new Uint8Array(array)]);

        // this code below will download the file we selected
        const url = URL.createObjectURL(file);
        const a = document.createElement('a');
        a.href = url;
        a.download = dlFN;
        a.click();
        URL.revokeObjectURL(url);
      }
      catch {}
    }

    return (
      <CollapsibleCard title="review">
        {alert && (<Alert severity="info" sx={{ mb: 2 }}>{alert}</Alert>)}
        <Typography variant="subtitle1">History</Typography>
        {listItems && (<ReportList orderID={order.orderID} items={listItems} download={_downloadFile} remove={_deleteFile} />)}
        <Typography variant="subtitle1" mb={2}>Review</Typography>
        <Box>
            <TextField
                sx={{ mb: 2 }}
                fullWidth
                id="order-review-comment"
                label={order.status !== 'Completed' ? 'Review Comment' : 'Re-open Order With Comment...'}
                multiline
                rows={2}
                placeholder="Enter..."
                value={comment}
                onChange={_handleInputChange}
                disabled={isSubmitting}
            />

            {toast[0] && <Alert severity={toast[0]}>{toast[1]}</Alert>}
            {isSubmitting ? (
              <Stack justifyContent="center" alignItems="center" p={4}>
                <CircularProgress />
              </Stack>
            ) : (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Box>
                  <Button disableElevation disabled={isSubmitting} variant="outlined" color="error" sx={{ mt:2, mr: 2 }} onClick={() => _submitReview(false, null)}>Request Changes</Button>
                  {order.status !== 'Completed' && <Button disableElevation disabled={isSubmitting} variant="contained" sx={{ mt:2 }} onClick={_handleApproval}>Send to Lender</Button>}
                </Box>
              </Box>
            )}
        </Box>

        <FileSelectDialog
          open={confirm}
          onConfirm={(pdfTimestamp) => _submitReview(true, pdfTimestamp)}
          onClose={() => setConfirm(false)}
          orderID={order.orderID}
          listItems={listItems}
        />

        <CustomDialog
          open={paymentDialog}
          title='Confirm'
          showConfirm={true}
          confirmMsg='Accept'
          onConfirm={() => setConfirm(true)}
          showClose={true}
          closeMsg='Cancel'
          onClose={() => setPaymentDialog(false)}
        >This order hasn't been paid yet. Do you still want to proceed with approval?</CustomDialog>

        <ModalConfirm
          show={message}
          onAccept={() => setMessage('')}
          onDecline={() => setMessage('')}
        >
          <div style={{ fontSize: '16px' }}>
            {message}
          </div>
        </ModalConfirm>
      </CollapsibleCard>
    )
}